// modules
// import './setup/webVitals'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'regenerator-runtime/runtime'
import React from 'react'
import { createRoot } from 'react-dom/client'

import './setup/sentry'
import './setup/config'
// components
import Root from './setup/root'
import {
  sendStartupProfilerEvent,
  StartupProfilerEventType,
} from '$logic/profiler/startup'

const render = () => {
  const container = document.getElementById('root')
  const root = createRoot(container)
  root.render(<Root />)
}
render()

sendStartupProfilerEvent(StartupProfilerEventType.EXECUTE_JS_FILES)
